import { Typography } from '@/components/UI/Typography'
import type { SpotPointStatusItem } from '@/domain/stamp/spotPointStatus'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SpotPointStatusRow } from './SpotPointStatusRow'

type Props = {
  items: SpotPointStatusItem[]
  /** スポット名タップ時に呼ばれる。spotId が null の行はタップ不可になる */
  onSelectSpot?: (spotId: number) => void
}

/**
 * スポットごとの獲得状況の一覧（#3582）。
 * スポットがない場合は空メッセージを表示する（PointHistoryList と同じ）。
 */
export const SpotPointStatusList: FC<Props> = ({ items, onSelectSpot }) => {
  const { t } = useTranslation()
  if (items.length === 0) {
    return (
      <Typography variant="caption1" className="py-8 text-center" c="gray.5">
        {t('common.no_data', 'データがありません')}
      </Typography>
    )
  }

  return (
    <ul>
      {items.map((item) => {
        const spotId = item.spotId
        return (
          <li key={item.key}>
            <SpotPointStatusRow
              label={item.label}
              earnedPoint={item.earnedPoint}
              availablePoint={item.availablePoint}
              onClick={onSelectSpot && spotId !== null ? () => onSelectSpot(spotId) : undefined}
            />
          </li>
        )
      })}
    </ul>
  )
}
